import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import EventLocationListChild from "./EventLocationListChild";

const EventLocationList = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <EventLocationListChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default EventLocationList;
